import {Component, Input, ElementRef, HostListener, OnInit, AfterViewInit} from '@angular/core';
import * as $ from 'jquery';
declare var window;

@Component({
  selector: 'app-journal-post-hero',
  templateUrl: './journal-post-hero.component.html',
  styleUrls: ['./journal-post-hero.component.scss']
})
export class JournalPostHeroComponent implements OnInit, AfterViewInit {
  @Input() content: any;
  @Input() postIndex: number;
  $content;
  contentOffsetMargin = '0px'; // used for bringing up hero image in line with title

  constructor(
    private el: ElementRef
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.setContentMarginTop();
  }

  setContentMarginTop() {
    if (this.$content) {
      const windowWidth = $(window).width();
      if (windowWidth >= 992) {
        this.contentOffsetMargin = '-' + (this.$content.height() + 60) + 'px';
      } else if (windowWidth >= 768) {
        this.contentOffsetMargin = '-' + (this.$content.height() + 50) + 'px';
      } else {
        this.contentOffsetMargin = '20px';
      }
    }
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.$content = $('[data-content]', this.el.nativeElement);

    setTimeout(() => {
      // inside settimeout to fix expressionchanged error
      this.setContentMarginTop();
    }, 1000);
  }
}
